import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-activeproblems/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of Active Problems
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchActiveProblemEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,alertnotification, settings: {
            epicendpoints:{
                activeproblems,apitoken
            },
            servers,
            uisettings: {
                dashboardapiconfig: {
                    activeproblems : activeproblemsApi
                }
            },
            compatible : { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        }} = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let payload: any = action.payload;
                const postActiveProblem = (activeprobrequest: any) => {
                    if (activeprobrequest?.id) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "PatientID": activeprobrequest.id,
                        }
                        let responseFromPost;
                        if (finesse_proxy_service) {
                            responseFromPost = InvokeFinesseProxy(activeproblems, data, apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            responseFromPost = server.post({
                                headers: headers,
                                path: activeproblems,
                                data: data,
                            })
                                .then((responseforap: any) => responseforap)
                                .catch((activeproblemerror: any) => {
                                    log.error(
                                        "ccw-gadget,activeproblems-epic",
                                        "active problems-epic", {
                                            activeproblemerror
                                    }
                                    );
                                    let errorbuild: ErrorObject={
                                        source:"ActiveProblems",
                                        type:"error",
                                        status:activeproblemerror?.status,
                                        erroritems:activeproblemerror?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,activeproblems-epic",
                                "activeproblems-epic response", {
                                    responseFromPost
                            });
                        }
                        return from(responseFromPost)
                    } else {
                        return from([]);
                    }
                }
                //Calling getReqeust function here
                //the reason is we need to use pipe function.
                if (!activeproblemsApi) return []
                return postActiveProblem(payload).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions:any =[
                                setAction(response.activeproblems)
                            ];
                            if(response.error){
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "1005" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta01 = payload.id;
                                disp.meta02 = response.error.status;
                                disp.meta03 = response.error.erroritems?.[0]?.error_detail;
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "188" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta01 = payload.id;
                                disp.meta02 = '200';
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * Listen for component clear and intiate state clear for Active Problems
 * @param context  contains logger which is used for logging
 */
export const clearActiveProblemEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, activeproblems-epic",
            "clear-activeproblems-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED,PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);